import router from '@/router'

const IMAGE_SERVER = process.env.VUE_APP_IMAGE_BASE;
const VIDEO_SERVER = process.env.VUE_APP_VIDEO_BASE;

export function checkMobile() {
    var userAgent = navigator.userAgent;
    var mobile = /(iPhone|iPad|Android|BlackBerry|Windows Phone)/i.test(userAgent);
    if(mobile){
        return true;
    }else{
        return false;
    }
}

export function convertFormData(data){
    const json = JSON.stringify(data);
    const blob = new Blob([json], {
        type: 'application/json'
    });

    return blob;
}

export function encodeFormData(formData) {
    const params = new URLSearchParams();
    for (const pair of formData.entries()) {
    params.append(pair[0], pair[1]);
    }
    return params.toString();
}

export function getImageUrl(image_url){

    if(image_url == "profile_default.jpg"){
        return require("@/assets/img/default_profile.png");
    }else{
        return IMAGE_SERVER + image_url;
    }

}

export function getVideoUrl(video_url){
    return VIDEO_SERVER + video_url;

}


export function goApp(type, idx){

    const ua = navigator.userAgent || '';
    const plat = navigator.userAgentData?.platform || navigator.platform || '';

    const isAndroid = /Android/i.test(ua) || plat === 'Android';
    const isIPhone  = /iPhone|iPod/i.test(ua);
    // iPadOS 13+는 종종 'Macintosh'로 보고하므로 터치포인트로 보정
    const isIPad    = /iPad/i.test(ua) || (/(Macintosh)/.test(ua) && navigator.maxTouchPoints > 1);

    const isWindows = /Windows NT/i.test(ua) || /Win/.test(plat);
    const isMac     = ((/(Macintosh|Mac OS X)/.test(ua) || /Mac/.test(plat)) && !isIPad);


    // window.location.href = "https://pawinhand.kr"

    if (isIPhone || isIPad) {
        // const startTime = new Date().getTime();
        // window.location.href = "pawinhand://kr.pawinhand?type=" + type + "&idx=" + idx;

        // setTimeout(function () {
        //     // 앱 실행에 실패하면 대체 동작 수행
        //     goAppStore();
        // }, 5000);

        let hiddenAt = null;

        document.addEventListener("visibilitychange", function () {
            if (document.visibilityState === "hidden") {
                hiddenAt = Date.now();
            }
        });

        // function openApp() {
            hiddenAt = null;
            window.open("pawinhand://kr.pawinhand?type=" + type + "&idx=" + idx, '_blank', 'noopener,noreferrer');

            setTimeout(function () {
                if (!hiddenAt || Date.now() - hiddenAt < 2000) {
                    window.open("https://apps.apple.com/kr/app/id1019549518", '_blank', 'noopener,noreferrer');
                }
            }, 5000);
        // }
    } else if (isAndroid) {
        window.open("intent://kr.pawinhand?type="+type+"&idx="+idx+"#Intent;scheme=pawinhand;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;package=lost.animal.main;end", '_blank', 'noopener,noreferrer');
    }else if(isWindows){
        window.open("https://play.google.com/store/apps/details?id=lost.animal.main", '_blank', 'noopener,noreferrer');
    }else if(isMac){
        window.open("https://apps.apple.com/kr/app/id1019549518", '_blank', 'noopener,noreferrer');
    }
}

export function moveAppAlert(type, ref_idx){
    
    if (confirm("포인핸드 앱에서 자세한 정보를 확인하세요!")) {
        goApp(type, ref_idx);

    }
}

export function openRouteInNewTab(to) {
    const url = router.resolve(to).href
    window.open(url, '_blank', 'noopener')
}

export function openUrlInNewTab(type, idx, url) {

    switch(type){
        case 'abandon': case 'ABANDON': 
            window.open('/shelter/animal/' + idx, '_blank', 'noopener')
            break;
        case 'shelter': case 'SHELTER':
            window.open('/shelter/home/' + idx, '_blank', 'noopener')
            break;
        case 'lost' : case 'LOST':
            window.open('/lost/detail/' + idx, '_blank', 'noopener')
            break;
        case 'story' : case 'STORY':
            window.open('/story/detail/' + idx, '_blank', 'noopener')
            break;
        case 'home' : case 'HOME':
            window.open('/', '_blank', 'noopener')
            break;
        case 'donation': case 'DONATION':
            window.open('/donation/detail/' + idx, '_blank', 'noopener')
            break;
        case 'campaign': case 'CAMPAIGN':
            window.open('/campaign/detail/' + idx, '_blank', 'noopener')
            break;
        case 'web': case 'WEB':
            window.open(url, '_blank', 'noopener');
    }
}

export async function copyText(text) {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(String(text ?? ''))

      alert('클립보드에 복사되었습니다.');
      
      return true
    }
  } catch (_) { /* 무시 후 폴백 시도 */ }

  // ✅ 폴백 (iOS/Safari 포함 구형 브라우저 대응)
  try {
    const ta = document.createElement('textarea')
    ta.value = String(text ?? '')
    ta.setAttribute('readonly', '')
    ta.style.position = 'fixed'
    ta.style.top = '-1000px'
    document.body.appendChild(ta)
    ta.select()
    ta.setSelectionRange(0, ta.value.length) // iOS 대응
    const ok = document.execCommand('copy')
    document.body.removeChild(ta)
    return ok
  } catch (_) {
    return false
  }
}